import type { ZodObject, ZodRawShape } from "zod";
import { ContentType } from "./ContentType.js";
import { benefitsBlockSchema } from "./content-blocks/benefitsBlockSchema.js";
import { ckEditorBlockSchema } from "./content-blocks/ckEditorBlockSchema.js";
import { contactButtonBlockSchema } from "./content-blocks/contactButtonBlockSchema.js";
import { galleryBlockSchema } from "./content-blocks/galleryBlockSchema.js";
import { imageBannerBlockSchema } from "./content-blocks/imageBannerBlockSchema.js";
import { linkBlockSchema } from "./content-blocks/linkBlockSchema.js";
import { quoationBlockSchema } from "./content-blocks/quotationBlockSchema.js";
import { unorderedListSchema } from "./content-blocks/unorderedListSchema.js";

export const contentBlockSchemaMap = {
	[ContentType.Gallery]: galleryBlockSchema,
	[ContentType.CKEditor]: ckEditorBlockSchema,
	[ContentType.ImageBanner]: imageBannerBlockSchema,
	[ContentType.ContactButton]: contactButtonBlockSchema,
	[ContentType.Benefits]: benefitsBlockSchema,
	[ContentType.Link]: linkBlockSchema,
	[ContentType.Quotation]: quoationBlockSchema,
	[ContentType.UnorderedList]: unorderedListSchema,
} satisfies Record<ContentType, ZodObject<ZodRawShape>>;
